import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Button,
  Grid,
  InputLabel,
  FormHelperText,
  Tooltip,
  MenuItem,
  Menu,
  Box,
  IconButton,
} from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import {
  getArchivalReportsData,
  getDocumentDetails,
  getDownloadedData,
  saveArchivalReport,
} from "../../api/archivalReportApi/archivalReportApi";
import { useLoader } from "../../context/LoaderContext";
import { AgGridReact, AgGridReactProps } from "ag-grid-react";
import { ColDef } from "ag-grid-enterprise";
import NavigationBar from "../NavigationBar/NavigationBarComponent";
import ExcelIcon from "../../assets/images/ExcelExport.png";
import InfoIcon from "@mui/icons-material/Info";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import GetAppIcon from "@mui/icons-material/GetApp";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  getUserGridPreference,
  saveUserGridPreference,
} from "../../api/userDataApi/userGridPreferenceAPI";
import { UserGridPreferenceModel } from "../../types/UserGridPreferenceModel";
import ArchivalReportDrawer from "./ArchivalReportDrawer";
import { Col, Form, Row } from "react-bootstrap";
import { appSettings } from "../../config/appSetting";
import CustomLoadingOverlay from "../CustomLoadingOverlay/CustomLoadingOverlay ";
import { useSnackbar } from "../Common/SnackbarContext";
import isPagePermission from "../../utils/common";
import PushPinIcon from "@mui/icons-material/PushPin";
import LocalStorageUtil from "../../utils/localStorage";

interface ArchivalReportProps {
  businessUnitData: any;
}

interface ActionsProps {
  data: any;
  businessUnitData: any;
  selectedButton: string;
  onDownload: (data: any) => Promise<void>;
  onView: (data: any) => Promise<void>;
  onInfo: (data: any) => void;
  onMenuAction: (actionType: number) => void;
}

const Actions: React.FC<ActionsProps> = ({
  data,
  businessUnitData,
  selectedButton,
  onDownload,
  onView,
  onInfo,
  onMenuAction,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const status = data?.status;

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (actionType?: number) => {
    setAnchorEl(null);
    if (actionType) {
      onMenuAction(actionType);
    }
  };

  return (
    <>
      <Tooltip title="Please Click to View the File">
        <RemoveRedEyeIcon
          className="icon-button-other"
          onClick={() => onView(data)}
          style={{
            padding: "0.2vh",
            color: "var(--aggrid-text-color)",
            cursor: "pointer",
          }}
        />
      </Tooltip>
      <Tooltip title="Please Click here to download document">
        <GetAppIcon
          className="icon-button-other"
          onClick={() => onDownload(data)}
          style={{
            padding: "0.2vh",
            color: "var(--aggrid-text-color)",
            cursor: "pointer",
          }}
        />
      </Tooltip>
      {isPagePermission(
        "Allow Metadata Information",
        "ArchivalReport",
        1441
      ) && (
        <Tooltip title="Click to View the file information and history">
          <InfoIcon
            className="icon-button-other"
            onClick={() => onInfo(data)}
            style={{
              padding: "0.2vh",
              color: "var(--aggrid-text-color)",
              cursor: "pointer",
            }}
          />
        </Tooltip>
      )}
      <MoreVertIcon
        className="icon-button-other"
        onClick={handleClick}
        style={{
          padding: "0.2vh",
          color: "var(--aggrid-text-color)",
          cursor: "pointer",
        }}
      />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleClose()}
        keepMounted
      >
        {(status === 11 || status === 9 || status===10) &&
        isPagePermission("Allow Completed", "ArchivalReport", 357) ? (
          <MenuItem
            className="context-menu-item"
            onClick={() => handleClose(1)}
          >
            Completed
          </MenuItem>
        ) : null}
        {(status === 3 ||
          status === 2 ||
          status === 5 ||
          status === 7 ||
          status === 6 ||
          status === 1) &&
        selectedButton === "DELETE" &&
        isPagePermission(
          "Allow Request For Deleting",
          "ArchivalReport",
          358
        ) ? (
          <MenuItem
            className="context-menu-item"
            onClick={() => handleClose(2)}
          >
            Request for Delete
          </MenuItem>
        ) : null}
        {(status === 3 ||
          status === 2 ||
          status === 5 ||
          status === 7 ||
          status === 6 ||
          status === 1) &&
        selectedButton === "DELETE" &&
        isPagePermission("Allow Approved For Delete", "ArchivalReport", 359) ? (
          <MenuItem
            className="context-menu-item"
            onClick={() => handleClose(3)}
          >
            Approve for Delete
          </MenuItem>
        ) : null}
        {(status === 1 ||
          status === 2 ||
          status === 3 ||
          status === 5 ||
          status === 7 ||
          status === 6 ||
          status === 15 ||
          status === 4) &&
        selectedButton === "ARCHIVAL" &&
        isPagePermission(
          "Allow Request For Archival",
          "ArchivalReport",
          353
        ) ? (
          <MenuItem
            className="context-menu-item"
            onClick={() => handleClose(4)}
          >
            Request for Archival
          </MenuItem>
        ) : null}
        {(status === 1 ||
          status === 2 ||
          status === 3 ||
          status === 15 ||
          status === 7 ||
          status === 6 ||
          status === 4) &&
        selectedButton === "ARCHIVAL" &&
        isPagePermission(
          "Allow Approved For Archival",
          "ArchivalReport",
          354
        ) ? (
          <MenuItem
            className="context-menu-item"
            onClick={() => handleClose(5)}
          >
            Approve for Archival
          </MenuItem>
        ) : null}
        {(status === 1 ||
          status === 2 ||
          status === 5 ||
          status === 7 ||
          status === 4 ||
          status === 3 ||
          status === 6 ||
          status === 15) &&
        isPagePermission("Allow Delayed", "ArchivalReport", 355) ? (
          <MenuItem
            className="context-menu-item"
            onClick={() => handleClose(6)}
          >
            Delayed
          </MenuItem>
        ) : null}
        {(status === 1 ||
          status === 2 ||
          status === 5 ||
          status === 7 ||
          status === 4 ||
          status === 3 ||
          status === 6 ||
          status === 15) &&
        isPagePermission("Allow Not Required", "ArchivalReport", 356) ? (
          <MenuItem
            className="context-menu-item"
            onClick={() => handleClose(7)}
          >
            Not Required
          </MenuItem>
        ) : null}
      </Menu>
    </>
  );
};

const ArchivalReport: React.FC<ArchivalReportProps> = ({
  businessUnitData,
}) => {
  const { showSnackbar } = useSnackbar();
  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const [startDateError, setStartDateError] = useState(false);
  const [endDateError, setEndDateError] = useState(false);
  const [rowData, setRowData] = useState<any[]>([]);
  const gridRef = useRef<AgGridReact>(null);
  const [filteredRowData, setFilteredRowData] = useState<any[]>([]);
  const [selectedButton, setSelectedButton] = useState("ARCHIVAL");
  const [selectedDocument, setSelectedDocument] = useState<any>(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [_gridApi, set_GridApi] = useState<AgGridReactProps | null>(null);// NOSONAR
  const [_gridPreferences, set_GridPreferences] = useState<any>(); // NOSONAR
  const [filteredSelectedData, setFilteredSelectedData] = useState<any[]>([]);
  const [archivalfilteredSelectedData, setArchivalfilteredSelectedData] =
    useState<any[]>([]);
  const onGridReady = (params: any) => {
    set_GridApi(params.api);
    params.api.setSideBarVisible(true);
  };
  const { setLoading } = useLoader();
  const pageSizeSelector = appSettings.agGridPageSizeSelector;
  const defaulPageSize = appSettings.agGridDefaulPageSize;
  const [_isSearchClick, set_IsSearchClick] = useState(false); // NOSONAR
  const formatter = new Intl.DateTimeFormat("en-GB", {
    timeZone: appSettings.timezone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const [arrDate, setArrDate] = useState<any[]>([]);
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    const date = new Date();
    const year = 2000;
    const till = date.getFullYear();
    const years = [];
    for (let y = year; y <= till; y++) {
      years.push(y);
    }
    setArrDate(years);
  }, []);

  const formatDate = (date: any) => {
    if (!date) return null;
    const parts = formatter.formatToParts(date).reduce((acc: any, part) => {
      acc[part.type] = part.value;
      return acc;
    }, {});
    return `${parts.year}-${parts.month}-${parts.day}`;
  };

  const toggleDrawer = (open: boolean) => () => {
    setDrawerOpen(open);
  };

  const handleDownloadPdf = async (data: any) => {
    const payload = {
      documentStreamID: data.documentStreamID,
      contextName:
        businessUnitData?.contextName ||
        LocalStorageUtil.getItem("contextName"),
    };
    try {
      setLoading(true);
      const response = await getDownloadedData(payload);
      if (response.status === 200) {
        const responseData = response.data;
        const contentType = response.headers["content-type"];
        const linkElement = document.createElement("a");
        const blob = new Blob([responseData], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        linkElement.href = url;
        linkElement.setAttribute("download", data.filename);
        const clickEvent = new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: false,
        });
        linkElement.dispatchEvent(clickEvent);
      }
    } catch (error) {
      console.log("Something went wrong:" + error);
    } finally {
      setLoading(false);
    }
  };

  const handleViewDocument = async (data: any) => {
    try {
      const id = data?.documentStreamID;
      if (!id) {
        throw new Error("Document Stream ID is missing.");
      }
      const encodedId = btoa(id);
      const mainUrl = window.location.origin;
      const url = `${mainUrl}/documentviewer?docstreamid=${encodedId}%3D`;
      const payload = {
        DocumentStreamId: encodedId,
        contextName: businessUnitData.contextName,
      };
      const newWindow = window.open(url, "_blank", "width=1100,height=550");
      if (!newWindow) {
        throw new Error(
          "Failed to open a new window. Please disable pop-up blockers."
        );
      }
      const documentViewerModelInfo = await getDocumentDetails(payload);
      if (documentViewerModelInfo?.base64FileStream) {
        const pdfData = `data:application/pdf;base64,${documentViewerModelInfo.base64FileStream}`;
        newWindow.document.body.innerHTML = `
        <html>
          <head>
            <title>Document Viewer</title>
            <style>
              body, html {
                margin: 0;
                padding: 0;
                height: 100%;
                overflow: hidden;
              }
              iframe {
                border: none;
                width: 100%;
                height: 100%;
              }
            </style>
          </head>
          <body>
            <iframe
              src="${pdfData}#toolbar=0"
              width="100%"
              height="100%"
            ></iframe>
          </body>
        </html>
      `;
      } else {
        throw new Error("Failed to retrieve document data.");
      }
    } catch (error) {
      console.error("Error in viewDocument:", error);
    }
  };

  const handleInfoDocument = (data: any) => {
    setSelectedDocument(data);
    toggleDrawer(true)();
  };

  const handleMenuAction = (actionType: number) => {
    if (gridRef.current) {
      const selectedNodes = gridRef.current.api.getSelectedNodes();
      const selectedRows = selectedNodes.map((node) => node.data);
      if (selectedRows.length === 0) {
        showSnackbar(
          "Please select at least one row to perform this action.",
          true
        );
        return;
      }
      let statusValue = "";
      let status = 0;
      const filterRowData = selectedButton === "ARCHIVAL" ? rowData : filteredRowData;
      const updatedRowData = filterRowData.map((row: any) => {
        if (
          selectedRows.some(
            (selectedRow) =>
              selectedRow.documentStreamID === row.documentStreamID
          )
        ) {
          switch (actionType) {
            case 1:
              statusValue = "Completed";
              status = 12;
              return { ...row, statusValue: "Completed", status: 12 };
            case 2:
              statusValue = "Request for Delete";
              status = 3;
              return { ...row, statusValue: "Request for Delete", status: 3 };
            case 3:
              statusValue = "Approve for Delete";
              status = 5;
              return { ...row, statusValue: "Approve for Delete", status: 5 };
            case 4:
              statusValue = "Request for Archival";
              status = 2;
              return {
                ...row,
                statusValue: "Request for Archival",
                status: 2,
              };
            case 5:
              statusValue = "Approve for Archival";
              status = 4;
              return {
                ...row,
                statusValue: "Approve for Archival",
                status: 4,
              };
            case 6:
              statusValue = "Delayed";
              status = 6;
              return { ...row, statusValue: "Delayed", status: 6 };
            case 7:
              statusValue = "Not Required";
              status = 7;
              return { ...row, statusValue: "Not Required", status: 7 };
            default:
              return row;
          }
        }
        return row;
      }); // NOSONAR

      setFilteredSelectedData((prevFilteredData) => {
        const updatedFilteredData = [...prevFilteredData];

        selectedRows.forEach((selectedRow) => {
          const existingIndex = updatedFilteredData.findIndex(
            (row) => row.documentStreamID === selectedRow.documentStreamID
          );

          if (existingIndex !== -1) {
            updatedFilteredData[existingIndex] = {
              ...updatedFilteredData[existingIndex],
              statusValue: statusValue,
              status: status,
            };
          } else {
            selectedRow.statusValue = statusValue;
            selectedRow.status = status;
            updatedFilteredData.push(selectedRow);
          }
        }); // NOSONAR

        return updatedFilteredData;
      });

      if (selectedButton === "ARCHIVAL") {
        setRowData(updatedRowData);
      } else {
        setFilteredRowData(updatedRowData);
      }
    }
  };

  const actionsCellRenderer = (params: any) => (
    <Actions
      data={params.data}
      businessUnitData={businessUnitData}
      selectedButton={selectedButton}
      onDownload={handleDownloadPdf}
      onView={handleViewDocument}
      onInfo={handleInfoDocument}
      onMenuAction={handleMenuAction}
    />
  );

  const columnDefs = useMemo(() => {
    if (!rowData || rowData.length === 0) {
      return [];
    }

    const predefinedColumns: ColDef[] = [
      {
        width: 60,
        sortable: false,
        filter: false,
        colId: "checkboxSelection",
      },
      {
        headerName: "#",
        width: 90,
        sortable: false,
        filter: false,
        resizable: false,
        colId: "rowIndex",
        valueGetter: (params: any) =>
          params.node ? (params.node.rowIndex ?? 0) + 1 : 0,
      },
      {
        headerName: "Document ID",
        field: "documentId",
        tooltipField: "DocumentID",
        enableRowGroup: true,
        autoHeight: true,
        width: 150,
        cellClass: "textFormat",
        colId: "col3",
      },
      {
        headerName: "File Name",
        field: "filename",
        enableRowGroup: true,
        tooltipField: "FileName",
        autoHeight: true,
        filter: "agTextColumnFilter",
        filterParams: {
          clearButton: true,
          applyButton: true,
          debounceMs: 200,
        },
        colId: "col4",
      },
      {
        headerName: "Project ID",
        field: "projectId",
        enableRowGroup: true,
        tooltipField: "ProjectID",
        autoHeight: true,
        filter: "agTextColumnFilter",
        filterParams: {
          clearButton: true,
          applyButton: true,
          debounceMs: 200,
        },
        colId: "col5",
      },
      {
        headerName: "Archiving Year",
        field: "archivingYear",
        enableRowGroup: false,
        tooltipField: "AchivingYear",
        autoHeight: true,
        width: 160,
        editable: true,
        sortable: false,
        cellEditor: "agSelectCellEditor",
        filterParams: {
          clearButton: true,
          applyButton: true,
          debounceMs: 200,
        },
        cellEditorParams: {
          values: arrDate,
        },
        valueGetter: function (rowData: any) {
          if (
            rowData.data?.archivingMonth !== "" &&
            rowData.data?.archivingMonth !== null
          ) {
            return (
              rowData.data?.archivingMonth + " / " + rowData.data?.archivingYear
            );
          } else {
            return rowData.data?.archivingYear;
          }
        },
      },
      {
        headerName: "To Location",
        field: "toLocation",
        enableRowGroup: true,
        tooltipField: "ToLocation",
        autoHeight: true,
        filter: "agTextColumnFilter",
        width: 300,
        filterParams: {
          clearButton: true,
          applyButton: true,
          debounceMs: 200,
        },
        colId: "col7",
      },
      {
        headerName: "Status",
        field: "statusValue",
        tooltipField: "Status",
        enableRowGroup: false,
        autoHeight: true,
        colId: "col8",
      },
      {
        headerName: "Actions",
        field: "link",
        cellRenderer: actionsCellRenderer,
        lockPinned: true,
        suppressSizeToFit: true,
        width: 200,
        pinned: "right" as const,
      },
    ];
    const allColumns: ColDef[] = [...predefinedColumns];
    return allColumns;
  }, [rowData, selectedButton]);

  const columnDefsForDelete = useMemo(() => {
    if (!filteredRowData || filteredRowData.length === 0) {
      return [];
    }
    const headersDisplayNames: Record<string, string> = {
      documentId: "Document ID",
      filename: "File Name",
      projectId: "Project ID",
      toLocation: "To Location",
      statusValue: "Status",
    };
    const predefinedColumns: ColDef[] = [
      {
        width: 50,
        sortable: false,
        filter: false,
        colId: "checkboxSelection",
      },
      {
        headerName: "#",
        width: 90,
        sortable: false,
        filter: false,
        resizable: false,
        colId: "rowIndex",
        valueGetter: (params: any) =>
          params.node ? (params.node.rowIndex ?? 0) + 1 : 0,
      },
      {
        headerName: "Actions",
        field: "link",
        cellRenderer: actionsCellRenderer,
        lockPinned: true,
        suppressSizeToFit: true,
        width: 200,
        pinned: "right" as const,
      },
    ];
    const generateDynamicColumns = (
      filteredRowData: any[],
      selectedHeaders: string[]
    ): ColDef[] => {
      if (!filteredRowData || filteredRowData.length === 0) {
        return [];
      }
      const columnsToExclude = [
        "accountId",
        "archivingYear",
        "archivingMonth",
        "status",
        "oldStatus",
        "requestEmailFlag",
        "documentStreamID",
        "level1Values",
        "fromDate",
        "toDate",
        "recordCount",
        "domainName",
        "fileStream",
        "metadatavalues",
        "stage",
        "locationUrl",
        "isSuperAdmin",
        "userId",
        "noOfRecords",
        "currentPage",
        "sortColumn",
        "sortOrder",
        "totalRecords",
        "isexporttpExcel",
        "contextName",
      ];
      return Object.keys(filteredRowData[0])
        .filter(
          (key) =>
            selectedHeaders.includes(key) && !columnsToExclude.includes(key)
        )
        .map((key) => ({
          headerName: headersDisplayNames[key] || key,
          field: key,
          tooltipField: key,
          width: 300,
          flex: 1,
          colId: key,
          sortable: true,
          filter: true,
          enableRowGroup: true,
        }));
    };
    const generateHeadersMap = (
      filteredRowData: any[]
    ): Record<string, string[]> => {
      if (!filteredRowData || filteredRowData.length === 0) {
        return {};
      }
      const availableHeaders = Object.keys(filteredRowData[0]);
      return {
        default: availableHeaders,
      };
    };
    const headersMap =
      filteredRowData && filteredRowData.length > 0
        ? generateHeadersMap(filteredRowData)
        : {};
    const selectedHeaders = headersMap.default || [];
    const dynamicColumns = generateDynamicColumns(
      filteredRowData,
      selectedHeaders
    );
    const allColumns: ColDef[] = [...predefinedColumns, ...dynamicColumns];
    return allColumns;
  }, [filteredRowData, selectedButton]);

  const getUserGridPreferencesData = async () => {
    setShowLoader(true);
    try {
      const workInProgressModelInfo: UserGridPreferenceModel = {
        Area:
          selectedButton !== "DELETE"
            ? "ArchivalReport-Archival"
            : "ArchivalReport-Delete",
        UserID: Number(LocalStorageUtil.getItem("userId")),
        BusinessUnitID: Number(LocalStorageUtil.getItem("businessUnitId")),
        ContextName:
          businessUnitData?.contextName ||
          LocalStorageUtil.getItem("contextName"),
        GridBlob: "",
        LastModifiedBy: "DocDistro-UserGridPreferencesAPI",
        LastModifiedDate: new Date().toISOString(),
      };
      const workInProgressData = await getUserGridPreference(
        workInProgressModelInfo
      );
      return workInProgressData;
    } catch (error) {
      console.error("Error fetching data", error);
    } finally {
      setShowLoader(false);
    }
  };

  const applyGridPreferences = (gridPreferences: any) => {
    if (gridPreferences) {
      try {
        const gridState = JSON.parse(gridPreferences);
        if (gridRef.current) {
          gridRef.current.api.applyColumnState({
            state: gridState,
            applyOrder: true,
          });

          gridRef.current.api.setFilterModel(gridState);
          gridRef.current.api.applyColumnState(gridState);
        }
      } catch (error) {
        console.error("Error parsing grid preferences:", error);
      }
    } else {
      console.warn("No grid preferences found or GridBlob is undefined.");
    }
  };

  const handleApplyClick = async () => {
    set_IsSearchClick(true);
    let valid = true;
    if (!startDate) {
      setStartDateError(true);
      valid = false;
    } else {
      setStartDateError(false);
    }
    if (!endDate) {
      setEndDateError(true);
      valid = false;
    } else {
      setEndDateError(false);
    }
    if (!valid) {
      return;
    }
    const payload = {
      AccountId:
        businessUnitData?.accountId || LocalStorageUtil.getItem("accountId"),
      DomainName: "",
      Fromdate: formatDate(startDate),
      IsSuperAdmin: "1",
      Todate: formatDate(endDate),
      contextName:
        businessUnitData?.contextName ||
        LocalStorageUtil.getItem("contextName"),
    };
    setShowLoader(true);
    try {
      const response = await getArchivalReportsData(payload);
      setArchivalfilteredSelectedData(response[0]);
      setRowData(response[0]);
      setFilteredRowData(response[1]);
      const gridPreferences = await getUserGridPreferencesData();
      if (gridPreferences) {
        applyGridPreferences(gridPreferences);
        set_GridPreferences(gridPreferences);
      }
    } catch (error) {
      console.log("failed to load", error);
    } finally {
      setShowLoader(false);
    }
  };

  const handleReset = () => {
    setStartDate(null);
    setEndDate(null);
    setEndDateError(false);
    setStartDateError(false);
    setRowData([]);
    set_IsSearchClick(false);
  };

  const handleButtonClick = (type: string) => {
    setSelectedButton(type);
    if (type === "DELETE") {
      setFilteredRowData(filteredRowData); // NOSONAR
    } else if (type === "ARCHIVAL") {
      setRowData(archivalfilteredSelectedData);
    }
  };

  const handleExcelData = () => {
    if (gridRef.current) {
      gridRef.current.api.exportDataAsExcel({
        fileName: "Archival Reports",
        sheetName: "Archival Report",
        processCellCallback: function (params) {
          return params.value;
        },
      });
    }
  };

  const handleSubmitClick = async () => {
    try {
      if (filteredSelectedData.length === 0) {
        showSnackbar("Please select at least one row to submit.", true);
        return;
      }
      setLoading(true);
      let lstParams: any[] = [];
      filteredSelectedData.forEach((row: any) => {
        const params = {
          AccountId: Number(LocalStorageUtil.getItem("accountId")),
          DocumentId: row.documentId,
          Filename: row.filename,
          ProjectId: row.projectId,
          ArchivingMonth: row.archivingMonth,
          ArchivingYear: row.archivingYear,
          Status: row.status,
          StatusValue: row.statusValue,
          RequestEmailFlag: row.requestEmailFlag,
          ToLocation: row.toLocation,
          DocumentStreamID: row.documentStreamID,
          Level1Values: row.level1Values,
          FromDate: formatDate(startDate),
          ToDate: formatDate(endDate),
          Timezone: appSettings.timezone,
          DomainName: row.domainName,
          IsSuperAdmin: Number(row.isSuperAdmin),
          UserId: Number(LocalStorageUtil.getItem("userId")),
          LocationUrl: row.locationUrl,
          contextName: LocalStorageUtil.getItem("contextName"),
        };
        lstParams.push(params);
      });

      await saveArchivalReport(lstParams);
      showSnackbar(
        "Records Submitted Successfully.Please click on apply to view the records."
      );
      setFilteredSelectedData([]);
    } catch (error) {
      console.log("Error submitting data:", error);
    } finally {
      setLoading(false);
    }
    console.log(filteredSelectedData);
  };

  const handleSaveGridPreferences = async () => {
    setLoading(true);
    if (gridRef.current) {
      const gridState = gridRef.current.api.getColumnState();
      const userGridPreference: UserGridPreferenceModel = {
        Area:
          selectedButton !== "DELETE"
            ? "ArchivalReport-Archival"
            : "ArchivalReport-Delete",
        UserID: Number(LocalStorageUtil.getItem("userId")),
        BusinessUnitID:
          businessUnitData?.businessUnitId ||
          Number(LocalStorageUtil.getItem("businessUnitId")),
        ContextName:
          businessUnitData?.contextName ||
          LocalStorageUtil.getItem("contextName")?.toString(),
        GridBlob: JSON.stringify(gridState),
        LastModifiedBy: "DocDistro-UserGridPreferencesAPI",
        LastModifiedDate: new Date().toISOString(),
      };
      try {
        const saveGrid = await saveUserGridPreference(userGridPreference);
        if (saveGrid) {
          showSnackbar("Grid state successfully saved.");
        }
      } catch (error) {
        console.error("Error saving grid preference", error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    const reapplyGridState = async () => {
      const gridPreferences = await getUserGridPreferencesData();
      if (gridPreferences) {
        applyGridPreferences(gridPreferences);
      }
    };
    reapplyGridState();
  }, [rowData, filteredRowData, selectedButton]);

  return (
    <div>
      <NavigationBar title="Archival Report" text="Archival Report" />
      <Row style={{ margin: "1em" }}>
        <Col>
          <Box>
            <div className="rp-main-inner col-sm-12">
              <div className="queue-top row clearfix">
                <div
                  className="col-sm-8"
                  style={{
                    display: "flex",
                    gap: "0.625em",
                    alignItems: "flex-start",
                    flexWrap: "wrap",
                    marginTop: "1.25em",
                    width: "66%",
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <InputLabel
                      style={{
                        color: "var(--text-color)",
                        marginBottom: "0.25em",
                        fontWeight: 600,
                        fontSize: "11px",
                      }}
                    >
                      From Date: *
                    </InputLabel>
                    <Form.Control
                      type="date"
                      placeholder="From Date"
                      name="fromdate"
                      max={new Date().toISOString().split("T")[0]}
                      value={
                        startDate ? startDate.toISOString().split("T")[0] : ""
                      }
                      onChange={(e) => setStartDate(new Date(e.target.value))}
                      style={{
                        padding: ".3em",
                        width: "150px",
                        fontSize: "11px",
                        borderRadius: "0",
                        border: "1px solid #ccc",
                        borderColor: "black",
                        marginTop: ".1em",
                      }}
                    />
                    <div style={{ height: "1.25em" }}>
                      {startDateError && (
                        <FormHelperText error sx={{ marginTop: "0.25em" }}>
                          Please select date
                        </FormHelperText>
                      )}
                    </div>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <InputLabel
                      style={{
                        color: "var(--text-color)",
                        marginBottom: "0.25em",
                        fontWeight: 600,
                        fontSize: "11px",
                        marginLeft: ".5em",
                      }}
                    >
                      To Date: *
                    </InputLabel>
                    <Form.Control
                      type="date"
                      placeholder="To Date"
                      name="todate"
                      value={endDate ? endDate.toISOString().split("T")[0] : ""}
                      max={new Date().toISOString().split("T")[0]}
                      onChange={(e) => setEndDate(new Date(e.target.value))}
                      style={{
                        padding: ".3em",
                        width: "150px",
                        fontSize: "11px",
                        borderRadius: "0",
                        border: "1px solid #ccc",
                        borderColor: "black",
                        marginTop: ".1em",
                        marginLeft: ".5em",
                      }}
                    />
                    <div style={{ height: "1.25em" }}>
                      {endDateError && (
                        <FormHelperText error sx={{ marginTop: "0.25em" }}>
                          Please select date
                        </FormHelperText>
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "0.5em",
                      alignItems: "center",
                      marginTop: "1.3em",
                      fontSize: "14px",
                    }}
                  >
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleApplyClick}
                      className="button apply-button"
                      style={{
                        marginLeft: ".5em",
                      }}
                    >
                      Apply
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleReset}
                      className="button reset-button"
                    >
                      Reset
                    </Button>
                  </div>
                </div>
                <div
                  className="col-sm-4"
                  style={{
                    display: "flex",
                    justifyContent: "right",
                    alignItems: "right",
                    marginTop: "4vh",
                    width: "15%",
                    height: "1.875em",
                    marginLeft: "32vh",
                  }}
                >
                  {rowData.length > 0 &&
                    isPagePermission(
                      "Allow Export To Excel",
                      "ArchivalReport",
                      352
                    ) && (
                      <>
                        <Tooltip title="Click to save grid state">
                          <IconButton
                            onClick={handleSaveGridPreferences}
                            className="preference-icon"
                          >
                            <PushPinIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Click to export the grid content in excel">
                          <button
                            type="button"
                            onClick={handleExcelData}
                            style={{
                              background: "none",
                              border: "none",
                              padding: 0,
                              cursor: "pointer",
                            }}
                            aria-label="Export to Excel"
                          >
                            <img
                              src={ExcelIcon}
                              className="excel-icon"
                              alt="Excel Icon"
                            />
                          </button>
                        </Tooltip>
                      </>
                    )}
                </div>
                {(rowData.length > 0 || filteredRowData?.length > 0) && (
                  <div
                    className="col-sm-8"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "1vh",
                      marginTop: "2vh",
                    }}
                  >
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor:
                          selectedButton === "ARCHIVAL"
                            ? "primary.main"
                            : "var(--button-background-color)",
                      }}
                      onClick={() => handleButtonClick("ARCHIVAL")}
                    >
                      ARCHIVAL ({rowData?.length})
                    </Button>
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor:
                          selectedButton === "DELETE"
                            ? "primary.main"
                            : "var(--button-background-color)",
                      }}
                      onClick={() => handleButtonClick("DELETE")}
                    >
                      DELETE ({filteredRowData?.length})
                    </Button>
                  </div>
                )}
                <div className="queue-table-view clearfix">
                  <div
                    className="ag-theme-quartz-dark"
                    style={{
                      height: "64vh",
                      width: "99%",
                      marginTop: "2vh",
                    }}
                  >
                    {selectedButton === "ARCHIVAL" ? (
                      <AgGridReact
                        columnDefs={columnDefs}
                        rowData={rowData}
                        onGridReady={onGridReady}
                        ref={gridRef}
                        pagination={true}
                        paginationPageSize={defaulPageSize}
                        paginationPageSizeSelector={pageSizeSelector}
                        sideBar={{ toolPanels: ["columns", "filters"] }}
                        headerHeight={30}
                        rowGroupPanelShow="always"
                        pivotPanelShow="always"
                        gridOptions={{
                          rowSelection: {
                            mode: "multiRow",
                            checkboxes: true,
                            headerCheckbox: true,
                            enableClickSelection: false,
                          },
                        }}
                        loading={!rowData || showLoader}
                        loadingOverlayComponent={CustomLoadingOverlay}
                        overlayNoRowsTemplate={
                          '<span class="ag-overlay-loading-center">No rows to show</span>'
                        }
                      />
                    ) : (
                      <AgGridReact
                        columnDefs={columnDefsForDelete}
                        rowData={filteredRowData}
                        onGridReady={onGridReady}
                        ref={gridRef}
                        pagination={true}
                        paginationPageSize={defaulPageSize}
                        paginationPageSizeSelector={pageSizeSelector}
                        sideBar={{ toolPanels: ["columns", "filters"] }}
                        headerHeight={30}
                        rowGroupPanelShow="always"
                        pivotPanelShow="always"
                        gridOptions={{
                          rowSelection: {
                            mode: "multiRow",
                            checkboxes: true,
                            headerCheckbox: true,
                            enableClickSelection: false,
                          },
                        }}
                        loading={!filteredRowData || showLoader}
                        loadingOverlayComponent={CustomLoadingOverlay}
                        overlayNoRowsTemplate={
                          '<span class="ag-overlay-loading-center">No rows to show</span>'
                        }
                      />
                    )}{" "}
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </Col>
      </Row>
      <Grid
        container
        spacing={2}
        sx={{
          marginTop: "1vh",
          display: "flex",
          justifyContent: "end",
        }}
        alignItems="center"
      >
        <Button
          variant="contained"
          sx={{
            bgcolor: "var(--button-background-color)",
            marginRight: "5vh",
          }}
          onClick={handleSubmitClick}
          className="update-button"
        >
          Submit
        </Button>
      </Grid>
      <ArchivalReportDrawer
        isOpen={drawerOpen}
        onClose={toggleDrawer(false)}
        tabLabels={["Information", "Version History"]}
        selectedDocument={selectedDocument}
        businessUnitData={businessUnitData}
      />
    </div>
  );
};

export default ArchivalReport;
